import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

const WebsiteAudit = () => {
  return (
    <section className="py-10 md:py-14 bg-muted/50">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-8 text-foreground">
            How Does Your Website Measure Up?
          </h2>
          <p className="text-xl md:text-2xl text-muted-foreground mb-12 max-w-3xl mx-auto leading-relaxed">
            Get a free comprehensive analysis of your website's ability to attract and convert 
            high-value clients. Discover what's working and what needs improvement.
          </p>
          <Button 
            size="lg"
            className="bg-secondary hover:bg-secondary/90 text-white font-semibold px-8 py-6 text-lg"
            asChild
          >
            <a href="/do-you-qualify">
              Get Your Free Website Audit <ArrowRight className="ml-2 h-5 w-5" />
            </a>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default WebsiteAudit;
